var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmileSvgrepoCom1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "30px",
    width: "30px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 473.931 473.931",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFC10E"
    },
    cx: 236.966,
    cy: 236.966,
    r: 236.966
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#333333"
    },
    cx: 164.937,
    cy: 152.997,
    r: 37.216
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#333333"
    },
    cx: 305.664,
    cy: 152.997,
    r: 37.216
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M236.951,362.678c-41.358-0.797-78.39-16.995-107.145-46.712c-8.4-8.685-21.616,4.561-13.227,13.227 c32.119,33.197,74.218,51.307,120.372,52.194C249.025,381.618,248.999,362.906,236.951,362.678L236.951,362.678z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M120.301,105.944c19.966-16.759,42.907-27.566,68.388-32.845 c11.809-2.447,6.795-20.482-4.977-18.043c-28.722,5.953-54.218,18.836-76.639,37.661 C97.821,100.481,111.13,113.648,120.301,105.944L120.301,105.944z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M291.079,68.152c24.871,7.794,46.42,21.126,64.553,39.835c8.408,8.677,21.624-4.565,13.227-13.227 c-20.34-20.988-44.939-35.917-72.803-44.654C284.508,46.491,279.607,64.553,291.079,68.152L291.079,68.152z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmileSvgrepoCom1);
export default __webpack_public_path__ + "static/media/smile-svgrepo-com (1).8598b11e47264af455e08db80be52c24.svg";
export { ForwardRef as ReactComponent };